import Vue from 'vue';
import Router from 'vue-router';
import wxPay from '@/pages/pay/wxPay';
import blank from '@/pages/other/blank';

//首页 home
const home = (r) => require.ensure([], () => r(require('@/pages/home/home')), 'home');
const notice = (r) => require.ensure([], () => r(require('@/pages/home/children/notice')), 'notice');
const notice_detail = (r) => require.ensure([], () => r(require('@/pages/home/children/children/notice_detail')), 'notice_detail');
const search = (r) => require.ensure([], () => r(require('@/pages/home/children/search')), 'search');

//登录注册 loginRegister
const login = (r) => require.ensure([], () => r(require('@/pages/loginRegister/login')), 'login');
const register = (r) => require.ensure([], () => r(require('@/pages/loginRegister/register')), 'register'); // 注册
const privacy = (r) => require.ensure([], () => r(require('@/pages/loginRegister/privacy')), 'privacy'); // 隐私政策
const privacyzhwk = (r) => require.ensure([], () => r(require('@/pages/loginRegister/privacyzhwk')), 'privacyzhwk'); // 隐私政策 -- 租号玩客
const forgetPassword = (r) => require.ensure([], () => r(require('@/pages/loginRegister/forgetPassword')), 'forgetPassword'); // 修改密码
const payPassword = (r) => require.ensure([], () => r(require('@/pages/loginRegister/payPassword')), 'payPassword'); // 设置支付密码
const rebateRegister = (r) => require.ensure([], () => r(require('@/pages/loginRegister/rebateRegister')), 'rebateRegister'); //下单返利注册

//商品 goods
const goodslist = (r) => require.ensure([], () => r(require('@/pages/goods/goods_list')), 'goodslist');
const goodsdetail = (r) => require.ensure([], () => r(require('@/pages/goods/goods_info')), 'goodsdetail');
const goodsAll = (r) => require.ensure([], () => r(require('@/pages/goods/goods_all')), 'goodsdetail');
const tips = (r) => require.ensure([], () => r(require('@/pages/goods/tips')), 'tips');

//订单 order
const order = (r) => require.ensure([], () => r(require('@/pages/order/order')), 'order');
const order_detail = (r) => require.ensure([], () => r(require('@/pages/order/orderDetail')), 'order_detail');

//支付 pay
const paySuccess = (r) => require.ensure([], () => r(require('@/pages/pay/paySuccess')), 'paySuccess');

// 公用微信支付页面
const weipay = (r) => require.ensure([], () => r(require('@/pages/pay/weipay')), 'weipay');
const wechatpay = (r) => require.ensure([], () => r(require('@/pages/pay/wechatpay')), 'wechatpay');

//我的 user
const my = (r) => require.ensure([], () => r(require('@/pages/user/my')), 'my');
const user_detail = (r) => require.ensure([], () => r(require('@/pages/user/user_detail')), 'user_detail');
const my_order = (r) => require.ensure([], () => r(require('@/pages/user/order/my_order')), 'my_order');
const settings = (r) => require.ensure([], () => r(require('@/pages/user/settings')), 'settings');
const coinTips = (r) => require.ensure([], () => r(require('@/pages/user/coinTips')), 'coinTips');
const myFreePlay = (r) => require.ensure([], () => r(require('@/pages/user/myFreePlay')), 'myFreePlay');

const arbitation = (r) => require.ensure([], () => r(require('@/pages/user/order/children/arbitation')), 'arbitation');
const rightsRules = (r) => require.ensure([], () => r(require('@/pages/user/order/children/rightsRules')), 'rightsRules');
const rightsProblem = (r) => require.ensure([], () => r(require('@/pages/user/order/children/rightsProblem')), 'rightsProblem');
const solveProblem = (r) => require.ensure([], () => r(require('@/pages/user/order/children/solveProblem')), 'solveProblem');
// 发布
const release = (r) => require.ensure([], () => r(require('@/pages/release/release')), 'release');
// 发布
const gameLogin = (r) => require.ensure([], () => r(require('@/pages/order/gameLogin')), 'gameLogin');
// 新老福利
const activeWelfare = (r) => require.ensure([], () => r(require('@/pages/active/welfare')), 'welfare');

const servicesDetail = (r) => require.ensure([], () => r(require('@/pages/other/servicesDetail')), 'servicesDetail');

const privacys = (r) => require.ensure([], () => r(require('@/pages/other/privacys')), 'privacys');

// 订单支付 - 选择优惠券
const orderCoupon = (r) => require.ensure([], () => r(require('@/pages/coupon/order_coupon')), 'orderCoupon');

// 优惠券管理
const couponManage = (r) => require.ensure([], () => r(require('@/pages/coupon/coupon_manage')), 'couponManage');
// 手动领取优惠券
const couponDiscount = (r) => require.ensure([], () => r(require('@/pages/coupon/coupon_discount')), 'couponDiscount');
// 客服投诉/建议
const ComplaintAdvice = (r) => require.ensure([], () => r(require('@/pages/complaint_advice/complaint_advice')), 'ComplaintAdvice');
// vantForm测试
const testOpen = (r) => require.ensure([], () => r(require('@/pages/complaint_advice/open')), 'testOpen');
// 实名认证
const authentication = (r) => require.ensure([], () => r(require('@/pages/user/authentication')), 'authentication');

const logout = (r) => require.ensure([], () => r(require('@/pages/user/logout')), 'logout');

const privacyConfig = (r) => require.ensure([], () => r(require('@/pages/user/auth/privacyConfig')), 'privacyConfig');

const systemAuth = (r) => require.ensure([], () => r(require('@/pages/user/auth/systemAuth')), 'systemAuth');

//暑期买券活动
const summerVacation = (r) => require.ensure([], () => r(require('@/pages/active/summer_vacation2022')), 'summerVacation');
// 公司简介
const companyProfile = (r) => require.ensure([], () => r(require('@/pages/other/companyProfile')), 'companyProfile');
//暑期买券活动
const contactUs = (r) => require.ensure([], () => r(require('@/pages/other/contactUs')), 'contactUs');

//贝壳活动
const julyActivity = (r) => require.ensure([], () => r(require('@/pages/july-active/july-activity')), 'julyActivity');

//贝壳活动任务中心
const taskCenter = (r) => require.ensure([], () => r(require('@/pages/july-active/task-center')), 'taskCenter');
const faceAuth = (r) => require.ensure([], () => r(require('@/pages/common/faceAuth')), 'faceAuth');

Vue.use(Router);

export default new Router({
	// mode: "history",
	routes: [
		{
			path: '/',
			component: home
		},
		{
			path: '/rebate_register',
			component: rebateRegister
		},
		{
			path: '/index',
			component: home
		},
		{
			path: '/notice',
			component: notice
		},
		{
			path: '/faceAuth',
			component: faceAuth
		},
		{
			path: '/notice_detail',
			component: notice_detail
		},
		{
			path: '/search',
			component: search
		},
		{
			path: '/goodslist',
			component: goodslist
		},
		{
			path: '/goodsdetail',
			component: goodsdetail
		},
		{
			path: '/goodsAll',
			component: goodsAll
		},
		{
			path: '/tips',
			component: tips
		},
		{
			path: '/my',
			component: my,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/user_detail',
			component: user_detail,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/settings',
			component: settings,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/cointips',
			component: coinTips,
			meta: {
				title: '',
				requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/myfreeplay',
			component: myFreePlay,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/my_order',
			component: my_order,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/arbitation',
			component: arbitation,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/rightsRules',
			component: rightsRules,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/rightsProblem',
			component: rightsProblem,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/solveProblem',
			component: solveProblem,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/login',
			component: login
		},
		{
			path: '/register',
			component: register
		},
		{
			path: '/privacy',
			component: privacy
		},
		{
			path: '/privacyzhwk',
			component: privacyzhwk
		},
		{
			path: '/forgetPassword',
			component: forgetPassword
		},
		{
			path: '/payPassword',
			component: payPassword,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/order',
			component: order,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/order_detail',
			component: order_detail,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/paySuccess',
			component: paySuccess,
			meta: {
				title: '',
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
			}
		},
		{
			path: '/weipay',
			component: weipay
		},
		{
			path: '/wechatpay',
			component: wechatpay
		},
		{
			path: '/wxpay', //新版微信支付
			component: wxPay
		},
		{
			path: '/weipay/wxpay', //新版微信支付
			component: wxPay
		},
		{
			path: '/blank', //空白页
			component: blank
		},
		{
			path: '/servicesDetail',
			component: servicesDetail
		},
		{
			path: '/privacys',
			component: privacys
		},
		{
			path: '/release',
			component: release
		},
		{
			path: '/gameLogin',
			component: gameLogin
		},
		{
			path: '/bindwx',
			component: (r) => require.ensure([], () => r(require('@/pages/other/BindWx')), 'bindwx'),
			meta: {
				title: '微信消息提醒'
			}
		},
		{
			path: '/welfare',
			component: activeWelfare
		},
		{
			path: '/order_coupon',
			component: orderCoupon
		},
		{
			path: '/coupon_manage',
			component: couponManage
		},
		{
			path: '/coupon_discount',
			component: couponDiscount
		},
		{
			path: '/complaint_advice',
			component: ComplaintAdvice
		},
		{
			path: '/authentication',
			component: authentication
		},
		{
			path: '/logout',
			component: logout
		},
		{
			path: '/privacyConfig',
			component: privacyConfig
		},
		{
			path: '/systemAuth',
			component: systemAuth
		},
		{
			path: '/summerVacation',
			component: summerVacation,
			meta: {
				title: '租号钜惠津贴，即领即用'
			}
		},
		{
			path: '/companyProfile',
			component: companyProfile,
			meta: {
				title: '公司简介'
			}
		},
		{
			path: '/contactUs',
			component: contactUs,
			meta: {
				title: '联系我们'
			}
		},
		{
			path: '/test_open',
			component: testOpen
		},
		{
			path: '/july-activity',
			component: julyActivity
		},
		{
			path: '/task-center',
			component: taskCenter
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js